"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSuspenseImageSlots = exports.default = exports.SuspenseImage = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _useSuspenseImage = _interopRequireDefault(require("../useSuspenseImage"));
var _suspenseImageClasses = require("./suspenseImageClasses");
var _jsxRuntime = require("react/jsx-runtime");
var getSuspenseImageSlots = function(_) {
    return {
        root: [
            'root'
        ]
    };
};
exports.getSuspenseImageSlots = getSuspenseImageSlots;
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = getSuspenseImageSlots(ownerState);
    return (0, _base.unstable_composeClasses)(slots, _suspenseImageClasses.getSuspenseImageUtilityClass, classes);
};
var SuspenseImageRoot = (0, _material.styled)('img', {
    name: 'MuiOriSuspenseImage',
    slot: 'Root',
    overridesResolver: function(_, styles) {
        return [
            styles.root
        ];
    }
})({});
var SuspenseImage = exports.SuspenseImage = /*#__PURE__*/ (0, _react.forwardRef)(function(inProps, ref) {
    var props = (0, _material.useThemeProps)({
        props: inProps,
        name: 'MuiOriSuspenseImage'
    });
    var component = props.component, src = props.src, srcSet = props.srcSet, className = props.className, shouldThrowError = props.shouldThrowError, _props_errorFallback = props.errorFallback, errorFallback = _props_errorFallback === void 0 ? null : _props_errorFallback, onerror = props.onerror, onload = props.onload, otherProps = _object_without_properties(props, [
        "component",
        "src",
        "srcSet",
        "className",
        "shouldThrowError",
        "errorFallback",
        "onerror",
        "onload"
    ]);
    var _ref = (0, _useSuspenseImage.default)({
        shouldThrowError: shouldThrowError,
        src: src,
        srcSet: srcSet,
        onerror: onerror,
        onload: onload
    }), isLoaded = _ref.isLoaded, error = _ref.error;
    var ownerState = _object_spread_props(_object_spread({}, props), {
        isLoaded: isLoaded,
        error: error,
        shouldThrowError: shouldThrowError
    });
    var classes = useUtilityClasses(ownerState);
    if (error !== undefined) {
        return errorFallback;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SuspenseImageRoot, _object_spread({
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        src: src,
        srcSet: srcSet
    }, otherProps));
});
var _default = exports.default = SuspenseImage; //# sourceMappingURL=SuspenseImage.js.map
